import commonPostTypeConfig from "../../common/postTypes/email";

export default function initPostType({wapp}) {
    return wapp.client.postTypes.getPostType({
        name: "email",
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager(),
    });
}
